/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelSubscriptionRequest
 */
export interface CancelSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof CancelSubscriptionRequest
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof CancelSubscriptionRequest
     */
    comment: string;
}

/**
 * Check if a given object implements the CancelSubscriptionRequest interface.
 */
export function instanceOfCancelSubscriptionRequest(value: object): value is CancelSubscriptionRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function CancelSubscriptionRequestFromJSON(json: any): CancelSubscriptionRequest {
    return CancelSubscriptionRequestFromJSONTyped(json, false);
}

export function CancelSubscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelSubscriptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'comment': json['comment'],
    };
}

export function CancelSubscriptionRequestToJSON(json: any): CancelSubscriptionRequest {
    return CancelSubscriptionRequestToJSONTyped(json, false);
}

export function CancelSubscriptionRequestToJSONTyped(value?: CancelSubscriptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'comment': value['comment'],
    };
}

